module.exports = __webpack_public_path__ + "img/d5.fde28c54.png";